import type {MigrationInterface, QueryRunner} from "typeorm";

export class AddStravaUploadColumn1787270400000 implements MigrationInterface {
  name = "AddStravaUploadColumn1787270400000";

  async up(queryRunner: QueryRunner): Promise<void> {
    await queryRunner.query(`ALTER TABLE "navigation" ADD COLUMN "stU" float`);
  }

  async down(queryRunner: QueryRunner): Promise<void> {
    await queryRunner.query(`ALTER TABLE "navigation" DROP COLUMN "stU"`);
  }
}
